(function () {
  if (window.__lookbookGalleryInit) return;
  window.__lookbookGalleryInit = true;

  function initSection(section) {
    const perPage    = parseInt(section.dataset.lbPerPage, 10) || 9;
    let activeCat    = section.dataset.lbActiveCat  || 'all';
    let activeYear   = section.dataset.lbActiveYear || 'all';
    let currentPage  = 1;
    let visiblePhotos = [];
    let rendered     = false;
    let swiperInstance = null;

    function allPhotos() {
      return Array.from(section.querySelectorAll('.lb-photo'));
    }

    function filterPhotos(cat, year) {
      return allPhotos().filter(p => {
        if (cat  !== 'all' && p.dataset.lbCat  !== cat.toLowerCase())  return false;
        if (year !== 'all' && p.dataset.lbYear !== year) return false;
        return true;
      });
    }

    function showPage(photos, page) {
      const grid = section.querySelector('[data-lb-grid]');
      const commit = () => {
        const offset  = (page - 1) * perPage;
        const pageSet = new Set(photos.slice(offset, offset + perPage));
        allPhotos().forEach(p => { p.style.display = pageSet.has(p) ? '' : 'none'; });
        const empty = section.querySelector('[data-lb-empty]');
        if (empty) empty.style.display = photos.length > 0 ? 'none' : '';
        renderPagination(photos, page);
        if (grid) grid.style.opacity = '';
      };
      if (rendered && grid) {
        grid.style.opacity = '0';
        setTimeout(commit, 180);
      } else {
        commit();
        rendered = true;
      }
    }

    function renderPagination(photos, page) {
      const bar = section.querySelector('[data-lb-pagination]');
      if (!bar) return;
      const total      = photos.length;
      const totalPages = Math.ceil(total / perPage) || 0;
      if (totalPages <= 1) { bar.innerHTML = ''; return; }
      const start = (page - 1) * perPage + 1;
      const end   = Math.min(page * perPage, total);
      bar.innerHTML =
        `<button class="lb-page-btn lb-page-btn--prev" data-lb-dir="-1"${page <= 1 ? ' disabled' : ''} aria-label="Página anterior">&#8592; Anterior</button>` +
        `<span class="lb-page-info">${start}–${end} de ${total} fotos</span>` +
        `<button class="lb-page-btn lb-page-btn--next" data-lb-dir="1"${page >= totalPages ? ' disabled' : ''} aria-label="Próxima página">Próximo &#8594;</button>`;
    }

    function closeDropdowns() {
      section.querySelectorAll('.lb-filter-dropdown.is-open').forEach(dd => {
        dd.classList.remove('is-open');
        dd.querySelector('.lb-filter-menu').hidden = true;
        dd.querySelector('.lb-filter-trigger').setAttribute('aria-expanded', 'false');
      });
    }

    function applyFilter(cat, year) {
      activeCat  = cat;
      activeYear = year;
      currentPage = 1;
      section.dataset.lbActiveCat  = cat;
      section.dataset.lbActiveYear = year;

      const catLabel  = section.querySelector('[data-lb-group="category"] .lb-filter-trigger-value');
      const yearLabel = section.querySelector('[data-lb-group="year"] .lb-filter-trigger-value');
      if (catLabel)  catLabel.textContent  = cat  === 'all' ? 'All Seasons' : cat;
      if (yearLabel) yearLabel.textContent = year === 'all' ? 'Year' : year.slice(2);

      section.querySelectorAll('[data-lb-filter="category"]').forEach(b => {
        b.classList.toggle('is-active', b.dataset.lbValue === cat);
      });
      section.querySelectorAll('[data-lb-filter="year"]').forEach(b => {
        b.classList.toggle('is-active', b.dataset.lbValue === year);
      });

      closeDropdowns();

      const p = new URLSearchParams();
      p.set('lb_cat', cat);
      p.set('lb_year', year);
      history.replaceState({}, '', location.pathname + '?' + p.toString());

      visiblePhotos = filterPhotos(cat, year);
      showPage(visiblePhotos, 1);
    }

    function navigatePage(dir) {
      const totalPages = Math.ceil(visiblePhotos.length / perPage);
      const newPage    = Math.max(1, Math.min(totalPages, currentPage + dir));
      if (newPage === currentPage) return;
      currentPage = newPage;
      showPage(visiblePhotos, currentPage);
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Lightbox (Swiper)
    function openLightbox(photo) {
      const modal   = section.querySelector('[data-lb-modal]');
      const wrapper = modal.querySelector('.swiper-wrapper');
      const idx     = Math.max(0, visiblePhotos.indexOf(photo));

      if (swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }

      wrapper.innerHTML = visiblePhotos.map(p =>
        `<div class="swiper-slide"><img class="lb-swiper__img" src="${p.dataset.lbImg}" alt="${p.dataset.lbAlt || ''}" draggable="false" /></div>`
      ).join('');

      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        swiperInstance = new Swiper(modal.querySelector('.lb-swiper'), {
          initialSlide: idx,
          loop: visiblePhotos.length > 1,
          speed: 420,
          keyboard: { enabled: true },
          navigation: {
            nextEl: modal.querySelector('.swiper-button-next'),
            prevEl: modal.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: modal.querySelector('.swiper-pagination'),
            type: 'fraction',
          },
        });
      });
    }

    function closeLightbox() {
      const modal = section.querySelector('[data-lb-modal]');
      modal.classList.remove('is-open');
      const inst = swiperInstance;
      swiperInstance = null;
      setTimeout(() => {
        if (inst) inst.destroy(true, true);
        modal.hidden = true;
      }, 300);
      document.body.style.overflow = '';
    }

    section._lbClose = closeLightbox;

    section.addEventListener('click', e => {
      const trigger = e.target.closest('.lb-filter-trigger');
      if (trigger) {
        const dd = trigger.closest('.lb-filter-dropdown');
        const isOpen = !dd.querySelector('.lb-filter-menu').hidden;
        closeDropdowns();
        if (!isOpen) {
          dd.classList.add('is-open');
          dd.querySelector('.lb-filter-menu').hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }
      const option = e.target.closest('.lb-filter-option');
      if (option) {
        const kind = option.dataset.lbFilter;
        const val  = option.dataset.lbValue;
        applyFilter(kind === 'category' ? val : activeCat, kind === 'year' ? val : activeYear);
        return;
      }
      const dirBtn = e.target.closest('[data-lb-dir]');
      if (dirBtn && !dirBtn.disabled) { navigatePage(parseInt(dirBtn.dataset.lbDir, 10)); return; }
      if (e.target.closest('[data-lb-close]')) { closeLightbox(); return; }
      if (e.target.closest('[data-lb-modal]') &&
          !e.target.closest('.lb-swiper__img') &&
          !e.target.closest('.swiper-button-prev, .swiper-button-next, .swiper-pagination')) {
        closeLightbox(); return;
      }
      const photo = e.target.closest('.lb-photo');
      if (photo && photo.style.display !== 'none') { openLightbox(photo); return; }
    });

    // Initialize
    visiblePhotos = filterPhotos(activeCat, activeYear);
    showPage(visiblePhotos, 1);
  }

  function onKey(e) {
    const modal = document.querySelector('.lookbook-gallery [data-lb-modal].is-open');
    if (!modal) return;
    const section = modal.closest('[data-section-id]');
    if (!section) return;
    if (e.key === 'Escape') section._lbClose();
  }

  function boot() {
    document.querySelectorAll('.lookbook-gallery').forEach(initSection);
    document.addEventListener('keydown', onKey);
    document.addEventListener('click', e => {
      if (!e.target.closest('.lb-filter-dropdown')) {
        document.querySelectorAll('.lb-filter-dropdown.is-open').forEach(dd => {
          dd.classList.remove('is-open');
          dd.querySelector('.lb-filter-menu').hidden = true;
          dd.querySelector('.lb-filter-trigger').setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.addEventListener('shopify:section:load', e => {
      e.target.querySelectorAll('.lookbook-gallery').forEach(initSection);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
